import * as Sentry from "@sentry/react";

import config from "@/config";

export function initSentry() {
  Sentry.init({
    dsn: "https://8f8f50721265ca6d2623023e1c47800c@o4509248770015232.ingest.us.sentry.io/4509248775847936",
    environment: config.env,
    release:
      import.meta.env.VITE_GIT_TAG ||
      import.meta.env.VITE_GIT_SHA ||
      "local",

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*\.stack\.expert/,
      /^\//,
    ],

    ignoreErrors: [
      /feature named `?\w+`? was not found/,
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers'\)/,
      "NotReadableError: The I/O read operation failed.",
      /Java object is gone/,
      "Network Error",
      /AxiosError: Network Error/,
      /Database deleted by request of the user/,
      "Login required",
      /Invalid call to runtime\.sendMessage\(\)/,
    ],

    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
    ],

    beforeSend(event) {
      const errorValue = event.exception?.values?.[0]?.value ?? "";
      if (/Network Error/i.test(errorValue)) {
        return null;
      }
      if (/login.required/i.test(errorValue)) {
        return null;
      }
      return event;
    },

    // Keep it cheap but useful:
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0, // 100% when an error happens

    sendDefaultPii: true,
  });
}

export function setSentryUserContext(
  user: { id: string; email?: string },
  orgId?: string,
) {
  Sentry.setUser({ id: user.id, email: user.email });
  if (orgId) {
    Sentry.setTag("org_id", orgId);
  }
}
